export default __webpack_public_path__ + "static/media/defaultcard.7ad71355.png";